// export const API_URL = "http://localhost:8443";
export const API_URL = "https://api.uptakemedical.com";

export const URLDATA = {
  url: API_URL + "/graphql",
  cturl: API_URL + "/api/Containers/uptake-ctscans/upload",
  ctcomplete: API_URL + "/UploadComplete",
  ctchunks: API_URL + "/UploadChunks",
  ctupload: API_URL + "/api/Ctscans/upload-ctscan",
  ctdownload: API_URL + "/api/Containers/download-files",
  ip3notification: API_URL + "/api/Ctscans/request-ip3",
};
